import { render, staticRenderFns } from "./newmultipleSelection.vue?vue&type=template&id=6779d94b&scoped=true&"
import script from "./newmultipleSelection.vue?vue&type=script&lang=js&"
export * from "./newmultipleSelection.vue?vue&type=script&lang=js&"
import style0 from "./newmultipleSelection.vue?vue&type=style&index=0&id=6779d94b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779d94b",
  null
  
)

export default component.exports